import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects';

import { hideLoader, showLoader } from '@topconagriculture/loader';
import { checkPermissions } from '@topconagriculture/casbin-react';
import { Action, Resource } from '@topconagriculture/permissions';

import api from '../../../core/api';
import { notificationError } from '../../../core/helpers/utils/notificationUtils';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import {
  deleteSelectedWeighbridgeTickets,
  deleteWeigbridgeTicket,
  getWeighbridgeTicketList,
  getWeighbridgeTicketTransactions,
  updateWeigbridgeTicket,
} from './weighbridge.actions';
import { compose403ErrorMessage, successHandler } from '../../../core/helpers/utils/sagaUtils';
import { LoadersNames } from '../../ui/ui.constants';
import { getFarmsListRequest } from '../farms/farms.actions';

function* getWeighbridgeTicketListSaga(action) {
  const { status, daysBack, endDate } = action.payload;
  const hasPermission = yield call(checkPermissions, { resource: Resource.FEED_WEIGHBRIDGE, action: Action.READ });
  if (!hasPermission) return;
  yield put(showLoader(LoadersNames.fetchWeighBridgeTickets));
  try {
    const result = yield call(api.weighbridge.getWeighbridgeTickets, status, endDate, daysBack);
    yield put(
      getWeighbridgeTicketList.done({
        result,
        params: action.payload,
      }),
    );
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
  yield put(hideLoader(LoadersNames.fetchWeighBridgeTickets));
}

function* updateWeigbridgeTicketSaga(action: ReturnType<typeof updateWeigbridgeTicket.started>) {
  try {
    const { id, ...payload } = action.payload;
    const result = yield call(api.weighbridge.updateWeighbridgeTicket, id, payload, false);
    yield put(
      updateWeigbridgeTicket.done({
        result,
        params: action.payload,
      }),
    );
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

function* deleteWeigbridgeTicketSaga(action: ReturnType<typeof deleteWeigbridgeTicket.started>) {
  const { payload, meta } = action;
  try {
    const result = yield call(api.weighbridge.deleteWeighbridgeTicket, payload);
    yield put(
      deleteWeigbridgeTicket.done({
        result,
        params: payload,
      }),
    );
    successHandler(meta);
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

function* deleteSelectedWeighbridgeTicketsSaga(action: ReturnType<typeof deleteSelectedWeighbridgeTickets.started>) {
  const { payload, meta } = action;
  try {
    const result = yield call(api.weighbridge.deleteMultipleWeighbridgeTickets, payload);
    yield put(
      deleteSelectedWeighbridgeTickets.done({
        result,
        params: payload,
      }),
    );
    successHandler(meta);
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

function* getWeighbridgeTicketTransactionsSaga(action: ReturnType<typeof getWeighbridgeTicketTransactions.started>) {
  const { payload } = action;
  try {
    const result = yield call(api.weighbridge.getWeighbridgeTicketTransactions, payload);
    yield put(
      getWeighbridgeTicketTransactions.done({
        result,
        params: payload,
      }),
    );
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
}

export function* watchWeighbridgeSaga() {
  yield all([
    yield takeLatest(getFarmsListRequest.done, getWeighbridgeTicketListSaga),
    yield takeLatest(getWeighbridgeTicketList.started, getWeighbridgeTicketListSaga),
    yield takeLatest(updateWeigbridgeTicket.started, updateWeigbridgeTicketSaga),
    yield takeLatest(deleteWeigbridgeTicket.started, deleteWeigbridgeTicketSaga),
    yield takeLatest(deleteSelectedWeighbridgeTickets.started, deleteSelectedWeighbridgeTicketsSaga),
    yield takeEvery(getWeighbridgeTicketTransactions.started, getWeighbridgeTicketTransactionsSaga),
  ]);
}
